export default __webpack_public_path__ + "static/supportMobile-2c75f2101b923caa7f3d470f28111d95.png";